<template lang="html">
    <section class="countdown">
        <div v-if="!hasAccessBothAdmin()">
            <strong style="color: red;">{{ $t("countdown.accessdenied") }}</strong>
        </div>

        <AdminTools></AdminTools>

        <div v-if="hasAccessBothAdmin()" class="countdown-content">
            <div class="countdown-addBtn">
                <button @click="createOrder();">+ {{ $t("countdown.creatnewcntd") }}</button>
            </div>
            <div class="countdown-form" v-if="showCreate">
                <b-container fluid>
                    <div class="countdown-error" v-if="errorMsg[getCurrentLang()]"><span>*</span> {{ errorMsg[getCurrentLang()] }}</div>
                    <b-form @submit="onSubmit" @reset="onReset" novalidate>
                        <b-row v-for="type in types" :class="'countdown-input m-' + type.name" :key="type.name">
                            <b-col>
                                <b-form-group :label="type.label[getCurrentLang()]" label-class="label-form" :label-for="type.name"></b-form-group>
                                <b-form-input
                                    v-model="form[type.name]"
                                    v-validate="type.required"
                                    :id="type.name"
                                    :type="type.type"
                                    :placeholder="type.placeholder"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <div class="row countdown-input m-standDesignList">
                            <label class="label-stand">{{ $t("countdown.colstanddesign") }}</label>
                            <div class="clearfix"></div>
                            <select :disabled="standDesignList.length == 0" v-model="form['standDesign']" class="selectStandDesign uppercase">
                                <option :value="standDefault" selected>--------</option>
                                <option v-for="(city_obj, city) in standDesignList" :key="city" :value="city_obj.id"> {{ city_obj.name }} </option>
                            </select>
                        </div>

                        <div class="countdown-textarea">
                            <div class="btnAddDesc" style="text-align: left;">
                                <span @click="showAddDesc();">{{ $t("countdown.adddesc") }}</span>
                            </div>
                            <div v-if="showDesc" v-for="(lang, key) in getLangsValue" :key="key" class="blocTextArea">
                                <label
                                    >{{ $t("countdown.adddesc") }} : <strong style="text-transform: uppercase">{{ lang.label }}</strong>
                                </label>
                                <div class="clearfix"></div>
                                <textarea
                                    class="textArea"
                                    v-model.trim="lang.value"
                                    :id="key"
                                    :name="lang.value"
                                    :key="key"
                                    rows="4"
                                    cols="40"
                                ></textarea>
                            </div>
                        </div>

                        <div class="countdown-action">
                            <b-button type="submit">{{ $t("countdown.btncreate") }}</b-button>
                            <b-button type="reset">{{ $t("countdown.btncancel") }}</b-button>
                        </div>
                    </b-form>
                </b-container>
            </div>
            <!-- ---------- -->
            <div class="countdown-addBtn">
                <button @click="showListCoundown();">+ {{ $t("countdown.listcntd") }}</button>
            </div>
            <div class="countdown-list" v-if="showList">
                <div v-if="getCountDown.length <= 0" class="listEmpty">{{ $t("countdown.emptycntd") }}</div>
                <div v-if="getCountDown.length > 0">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col">{{ $t("countdown.colname") }}</th>
                                <th scope="col">{{ $t("countdown.colstartdate") }}</th>
                                <th scope="col">{{ $t("countdown.colenddate") }}</th>
                                <th scope="col">{{ $t("countdown.colstanddesign") }}</th>
                                <th scope="col">{{ $t("countdown.colbrand") }}</th>
                                <th scope="col">{{ $t("countdown.colcreateupdate") }}</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(countDown, key) in getCountDown" :key="key">
                                <td class="name">{{ countDown.name }}</td>
                                <td>
                                    {{ convertGmtToLocal(new Date(countDown.startDate)).toLocaleString() }} <br />
                                    <span class="utcForamt">({{ countDown.startDate }} UTC)</span>
                                </td>
                                <td>
                                    {{ convertGmtToLocal(new Date(countDown.endDate)).toLocaleString() }} <br />
                                    <span class="utcForamt">({{ countDown.endDate }} UTC)</span>
                                </td>
                                <td>{{ countDown.standDesign.name }}</td>
                                <td>{{ countDown.standDesign.brand.name }}</td>
                                <td>
                                    <span class="dateAction"
                                        >Created : {{ new Date(countDown.createdAt).toLocaleString() }} <br />
                                        by {{ countDown.modifiedBy.firstname }} {{ countDown.modifiedBy.lastname }}</span
                                    >
                                </td>
                                <td>
                                    <img
                                        @click="openModalDeleteCountDown(countDown, 'deleteCountDown');"
                                        class="pointer"
                                        v-b-modal="'defaultModal'"
                                        src="../../../../static/assets/delete-icon.svg"
                                        width="30"
                                        height="30"
                                    />

                                    <img
                                        @click="openModalEditCountDown(countDown, 'editCountDown');"
                                        class="pointer"
                                        v-b-modal="'defaultModal'"
                                        src="../../../../static/assets/mod-icon.svg"
                                        width="30"
                                        height="30"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal :action="dataAction"></Modal>
        </div>
    </section>
</template>

<script lang="js">
import httpService from '../../service'
import connectionBO from '../../../services/connectionBO'
import Modal from './modal/Modal'
import {mapGetters, mapActions} from 'vuex'
import Globals from '../../../components/globals'
import AdminTools from "../../adminTools/Admin";
import cacheService from "@/services/cache";

export default {
    name: 'create-count-down',
    props: [],
    components: {
        connectionBO,
        Modal,
        AdminTools
    },
    mounted () {
    },
    data () {
        return {
            showCreate: true,
            showList: true,
            showDesc: false,
            errorMsg: [],
            dataAction: '',
            selected: null,
            standDefault: null,
            standDesignList: {},
            descriptionArea: null,
            getLangsValue: [],
            form: {
                name: '',
                dateStart: '',
                timeStart: '',
                dateEnd: '',
                timeEnd: '',
                standDesign: '',
                desc: ''
            },
            types: [
                {
                    name: 'name',
                    type: 'text',
                    placeholder: 'Name',
                    required: 'required',
                    label: {
                        en: 'Name',
                        fr: 'Nom'
                    }
                },
                {
                    name: 'dateStart',
                    type: 'date',
                    placeholder: '',
                    required: 'required',
                    label: {
                        en: 'Start date',
                        fr: 'Date début'
                    }
                },
                {
                    name: 'timeStart',
                    type: 'time',
                    placeholder: '',
                    required: 'required',
                    label: {
                        en: 'Start time',
                        fr: 'Heure début'
                    }
                },
                {
                    name: 'dateEnd',
                    type: 'date',
                    placeholder: '',
                    required: 'required',
                    label: {
                        en: 'End date',
                        fr: 'Date fin'
                    }
                },
                {
                    name: 'timeEnd',
                    type: 'time',
                    placeholder: '',
                    required: 'required',
                    label: {
                        en: 'End time',
                        fr: 'Heure fin'
                    }
                }
            ]
        }
    },
    created () {
        this.listCountDown()
        httpService.get('/admin/standDesigns/list')
            .then((response) => {
                this.standDesignList = response.data
            })

        this.getLangsValue = this.getLangs.map(v => {
            return {
                'label': v.label,
                'value': ''
            }
        })
    },
    watch: {},
    methods: {
        ...mapActions({
            listCountDown: 'countdown/listCountDown'
        }),
        getCurrentLang () {
            return cacheService.getUserLang()
        },
        /**
         * Transform date GTM
         * @param date
         * @returns {string}
         */
        transformDateToGmt (date) {
            let month = '' + (date.getUTCMonth() + 1)
            let day = '' + date.getUTCDate()
            let year = date.getUTCFullYear()

            if (month.length < 2) month = '0' + month
            if (day.length < 2) day = '0' + day

            return [year, month, day].join('-')

            // return date.getUTCFullYear() + '-' + ((date.getUTCMonth() + 1).length < 2) ? ('0' + (date.getUTCMonth() + 1)) : (date.getUTCMonth() + 1) + '-' + date.getUTCDate() + ' ' + date.getUTCHours() + ':' + ((date.getUTCMinutes() < 10) ? ('0' + date.getUTCMinutes()) : date.getUTCMinutes()) + ':00'
        },
        /**
         * Convert Date GTM to Local
         * @param dateGmt
         * @returns {Date}
         */
        convertGmtToLocal (dateGmt) {
            let newDate = new Date(dateGmt.getTime() + dateGmt.getTimezoneOffset() * 60000)

            let offset = dateGmt.getTimezoneOffset() / 60
            let hours = dateGmt.getHours()

            newDate.setHours(hours - offset)

            return newDate
        },
        createOrder () {
            this.showCreate = !this.showCreate
            this.form = {}
        },
        showListCoundown () {
            this.showList = !this.showList
        },
        showAddDesc () {
            this.showDesc = !this.showDesc
        },
        onReset (evt) {
            evt.preventDefault()
            this.errorMsg = ""
            this.form = {}
        },
        onSubmit (evt) {
            evt.preventDefault()
            let dateStart = new Date(this.form.dateStart + ' ' + this.form.timeStart + ':00')
            let dateEnd = new Date(this.form.dateEnd + ' ' + this.form.timeEnd + ':00')

            let newCountdown = {
                name: this.form.name,
                startDate: (this.form.dateStart && this.form.timeStart)
                    ? Globals.transformDateToGmt(dateStart)
                    : '',
                endDate: (this.form.dateEnd && this.form.timeEnd)
                    ? Globals.transformDateToGmt(dateEnd)
                    : '',
                standDesign: {
                    id: this.form.standDesign
                },
                translations: this.getLangsValue.map(v => {
                    return {
                        'field': 'description',
                        'locale': v.label,
                        'content': v.value
                    }
                })
            }

            if (newCountdown.name && newCountdown.startDate && newCountdown.endDate && newCountdown.standDesign.id) {
                if (dateStart.getTime() >= dateEnd.getTime()) {
                    this.errorMsg = {
                        en: 'End date must be greater than start date',
                        fr: 'La date de fin doit être supérieure àla date de début'
                    }
                } else {
                    connectionBO.postCountDown(newCountdown).then(response => {
                        if (response.code === 400 || response.code === 404) {
                            if (response.message === "countdown_name_duplicated") {
                                this.errorMsg = {
                                    en: 'A countdown with this name already exists',
                                    fr: 'Une période-promo avec ce nom existe déja'
                                }
                            } else {
                                this.errorMsg = {
                                    en: 'Error. Please contact application Support',
                                    fr: "Erreur. Veuillez contacter l'assistance "
                                }
                            }
                        } else {
                            this.listCountDown()
                            this.errorMsg = {
                                en: 'Countdown successfully created',
                                fr: 'La période-promo a bien été enregistrée'
                            }
                        }
                    })
                }
            } else {
                this.errorMsg = {
                    en: 'All fields are required',
                    fr: 'Tous les champs sont obligatoires'
                }
            }
        },
        openModalDeleteCountDown (dataCountDown, action) {
            this.dataAction = {
                action: action,
                data: dataCountDown
            }
            this.$root.$emit('bv::show::modal', 'defaultModal')
        },
        openModalEditCountDown (dataCountDown, action) {
            this.dataAction = {
                errorMsg: false,
                action: action,
                data: dataCountDown,
                formData: {
                    id: dataCountDown.id,
                    name: dataCountDown.name,
                    dateStart: this.transformDateToGmt(this.convertGmtToLocal(new Date(dataCountDown.startDate))).toLocaleString().substring(0, 10),
                    startDateBis: new Date(dataCountDown.startDate),
                    timeStart: this.convertGmtToLocal(new Date(dataCountDown.startDate))
                        .toLocaleString().substring(13, 18),
                    dateEnd: this.transformDateToGmt(this.convertGmtToLocal(new Date(dataCountDown.endDate))).toLocaleString().substring(0, 10),
                    endDateBis: new Date(dataCountDown.endDate),
                    timeEnd: this.convertGmtToLocal(new Date(dataCountDown.endDate))
                        .toLocaleString().substring(13, 18),
                    terms: dataCountDown.terms,
                    standDesign: dataCountDown.standDesign
                }
            }
            this.$root.$emit('bv::show::modal', 'defaultModal')
        }
    },
    computed: {
        ...mapGetters({
            getCountDown: 'countdown/getCountDown',
            getLangs: 'i18n/getLangs'
        })
    }
}
</script>

<style scoped lang="scss">
.countdown {
    width: 100%;
    &-content {
        text-align: center;
    }
    &-textarea {
        margin: 20px 15px;
        text-align: left;
        & .blocTextArea {
        }
        & .btnAddDesc {
            text-align: left;
            border-bottom: 1px dotted black;
            padding-bottom: 5px;
            margin-bottom: 10px;
            & span {
                font-size: 13px;
                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
                &:after {
                    content: "›";
                    display: inline-block;
                    margin-left: 5px;
                    font-size: 18px;
                }
            }
        }
        & .blocTextArea {
            display: inline-block;
            & label {
                color: black;
                margin-bottom: 10px;
                font-size: 12px;
                font-weight: normal;
                display: block;
            }
            &:nth-child(2n) {
                margin-right: 30px;
            }
        }
    }
    &-error {
        color: red;
        margin-bottom: 10px;
        & span {
            color: red;
        }
    }
    &-action {
        margin-top: 20px;
        & button {
            border: 1px solid black;
            background: white;
            color: black;
            border-radius: 0;
            padding: 5px 25px;
            &:hover {
                background: black;
                color: white;
                border-color: white;
            }
        }
    }
    &-addBtn {
        padding: 5px 0;
        background: #343434;
        border-bottom: 5px solid white;
        & button {
            color: white;
            background: none;
            font-size: 20px;
            border: none;
            &:hover {
                text-decoration: underline;
            }
            & span {
            }
        }
    }
    &-input {
        display: inline-block;
        position: relative;
        &:nth-child(1) {
            margin-right: 10px;
        }
        &:nth-child(3) {
            margin-right: 10px;
            left: -1px;
        }
        &:nth-child(5) {
            left: -1px;
        }
        &:nth-child(6) {
            margin-left: 7px;
        }
    }
    &-form {
        padding: 10px 0;
        margin-bottom: 10px;
        & form {
            width: 780px;
            margin: 0 auto;
        }
        & label {
            width: 100%;
            color: black;
            text-align: left;
            margin-bottom: 10px;
            font-size: 13px;
            display: block;
        }
        & input {
            border: 1px solid black;
            background: white;
            padding: 15px 5px;
            font-size: 13px;
            &[type="text"] {
                padding: 18px 5px;
            }
        }
        & select {
            background: white;
            padding: 15px 5px;
            border: 1px solid black;
        }
    }
    & input[aria-invalid="false"] {
        // border: 1px solid blue;
    }
    & input[aria-invalid="true"] {
        // border: 1px solid red;
    }
    &-list {
        & table {
            font-family: "oswald-regular", sans-serif;
            border-spacing: 0;
            & thead {
                & th {
                    font-weight: normal;
                    font-family: "oswald-regular", sans-serif;
                    font-size: 16px;
                    border: none;
                    vertical-align: middle;
                    padding: 15px 0;
                }
            }
            & tbody {
                color: #808080;
                & tr {
                    border-bottom: 1px solid #f2f2f2;
                    &:hover {
                        background: #f8f6ff;
                    }
                }
                & td {
                    vertical-align: middle;
                    padding: 15px 0;
                    & img {
                        position: relative !important;
                    }
                }
                & .name {
                    font-weight: bold;
                    font-size: 15px;
                }
                & .utcForamt {
                    font-size: 11px;
                }
                & .dateAction {
                    display: block;
                    text-transform: none;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// CreateCountDown.vue?42ba7705